import { useTheme } from '@mui/material';
const useSwipableDrawerStyles = () => {
    const theme = useTheme();
    return {
        SwipableDrawerStyles: {
            '.MuiDrawer-paper': {
                minHeight: 206,
                overflow: 'visible',
                borderTopLeftRadius: 12,
                borderTopRightRadius: 12
            }
        },
        PopupHeader: {
            display: 'flex',
            width: '100%',
            height: 48,
            mt: '14px',
            padding: '0px 16px 8px 16px',
            alignItems: 'flex-end',
            justifyContent: 'space-between'
        },
        PopupContentContainer: {
            padding: '8px 16px'
        },
        PopupBottomContainer: {},
        PopupBottomDivider: {},
        ResetButtonStyles: {
            color: theme.palette.text.disabled
        },
        PullerStyles: {
            width: 64,
            height: 4,
            flexShrink: 0,
            backgroundColor: theme.palette.text.disabled,
            borderRadius: 2,
            position: 'absolute',
            top: 8,
            marginBottom: 1,
            left: '50%',
            transform: 'translateX(-50%)',
        },
        PopupBottomSectionStyles: {
            width: '100%',
            height: 34
        }
    };
};
export default useSwipableDrawerStyles;
